import { render, staticRenderFns } from "./EditQuiz.vue?vue&type=template&id=3d649748&scoped=true"
import script from "./EditQuiz.vue?vue&type=script&lang=ts"
export * from "./EditQuiz.vue?vue&type=script&lang=ts"
import style0 from "./EditQuiz.vue?vue&type=style&index=0&id=3d649748&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d649748",
  null
  
)

export default component.exports